// extracted by mini-css-extract-plugin
export var modal = "ModalCookieConsent-module--modal--RMOAi";
export var modal_content = "ModalCookieConsent-module--modal_content--rJJJ-";